import type { AxisValue, ControlProps } from './types';

function asAxisValue(value: unknown): AxisValue {
  if (value && typeof value === 'object') {
    const v = value as Partial<AxisValue>;
    return { visible: v.visible !== false, title: typeof v.title === 'string' ? v.title : '' };
  }
  return { visible: true, title: '' };
}

/**
 * Composite control for whole-axis options (`{ visible, title }`). Most axis
 * customization is expressed as separate boolean/label schema entries; this
 * control exists for the `axis` option type in the contract.
 */
export function AxisControl({ schema, value, disabled, onChange }: ControlProps) {
  const axis = asAxisValue(value);
  return (
    <span className="cf-control-group cf-axis-control">
      <input
        type="text"
        aria-label={`${schema.label} title`}
        placeholder="Axis title"
        value={axis.title}
        disabled={disabled}
        onChange={(e) => onChange({ ...axis, title: e.target.value })}
      />
      <span className="cf-switch">
        <input
          type="checkbox"
          aria-label={`${schema.label} visible`}
          checked={axis.visible}
          disabled={disabled}
          onChange={(e) => onChange({ ...axis, visible: e.target.checked })}
        />
        <span className="cf-slider" />
      </span>
    </span>
  );
}
